<template>
  <div>
    <header>
      <div class="left">
        <h2>
          {{
            action_filters.assigneeId &&
            app_user &&
            action_filters.assigneeId.length === 1 &&
            action_filters.assigneeId[0] === app_user.id
              ? 'My'
              : 'Team'
          }}
          Tasks
        </h2>
        <p>
          Showing {{ totalResults }} result{{ totalResults !== 1 ? 's' : '' }}
        </p>
      </div>

      <div class="right">
        <a class="main-action" @click="newAction()">New task</a>
      </div>
    </header>

    <div>
      <div class="flex-between">
        <search-box :onChange="handleSearch" />

        <div class="flex-between pagination">
          <a class="outline-button" @click="showFilters()">
            <img src="~@/assets/icons/filters.svg" />
            Filters
          </a>
        </div>
      </div>

      <div
        v-for="(actionsForDate, key) of actionDates"
        :key="key"
        class="dateGroup"
      >
        <div class="date-title" :class="key">
          <hr />
          <span>{{ getHeading(key) }}</span>
          <hr />
        </div>

        <transition-group name="list" tag="div">
          <action-card
            v-for="action of actionsForDate"
            :key="`action-${action.id}`"
            :viewAction="viewAction"
            :action="action"
            className="wide"
          />
        </transition-group>
      </div>

      <div v-if="loadingNewData" class="loader">Loading...</div>
    </div>

    <action-filters :onApply="get_actions" />
  </div>
</template>

<script>
import ActionCard from '../components/ActionCard';
import SearchBox from '../components/SearchBox';
import ActionFilters from '../components/ActionFilters';
import moment from 'moment';

export default {
  name: 'Taskview',
  data() {
    return {
      search_term: '',
      actionDates: {},
      totalResults: 0,
      actionCount: 0,
      delay: { show: 700, hide: 0 },
      results_to_show: 50,
      scrollTimer: null,
      loadingNewData: false,
    };
  },
  computed: {
    app_user() {
      return this.$store.getters.app_user;
    },
    refresh_actions_trigger() {
      return this.$store.getters.refresh_actions_trigger;
    },
    projects() {
      return this.$store.getters.projects;
    },
    all_project_ids() {
      return this.$store.getters.all_project_ids;
    },
    action_filters() {
      return this.$store.getters.action_filters;
    },
  },
  methods: {
    async get_actions() {
      this.loadingNewData = true;
      await this.$store.dispatch('getAllProjects');

      const params = [
        { key: 'limit', value: this.results_to_show },
        { key: 'offset', value: 0 },
        { key: 'order', value: 'ASC' },
        { key: 'completed', value: false },
      ];

      Object.keys(this.action_filters).forEach(key => {
        let value = this.action_filters[key];

        if (Array.isArray(value)) {
          value = value.filter(v => v !== 'All');
        }

        if (value && value.length) {
          params.push({ key, value });
        }

        if (
          key === 'projectId' &&
          !value.length &&
          this.all_project_ids.length
        ) {
          params.push({ key, value: this.all_project_ids });
        }

        if (key === 'dates' && value.start) {
          params.push({ key: 'fromDueDate', value: value.start });

          if (!value.end) {
            params.push({ key: 'toDueDate', value: value.start });
          }
        }

        if (key === 'dates' && value.start) {
          params.push({ key: 'toDueDate', value: value.end });

          if (!value.start) {
            params.push({ key: 'fromDueDate', value: value.end });
          }
        }

        if (key === 'existLinkedDocs') {
          params.push({ key: 'existLinkedDocs', value });
        }
      });

      if (this.search_term) {
        params.push({ key: 'search', value: this.search_term });
      }

      const {
        actionDates,
        totalResults,
        actionCount,
      } = await this.$store.dispatch('getActions', params);
      this.actionDates = actionDates;
      this.totalResults = totalResults;
      this.actionCount = actionCount;

      this.loadingNewData = false;
    },
    lazyLoad() {
      this.results_to_show += 50;
      this.get_actions();
    },
    newAction() {
      this.viewAction();
    },
    viewAction(action, action_group_id, project_id) {
      if (action) {
        this.$store.dispatch('setCurrentActionId', action.id);
        this.$store.dispatch('setCurrentAction', action);
        this.$store.dispatch('getProjectDetail', action.projectId);
      } else {
        this.$store.dispatch('setNewActionGroupId', null);
        this.$store.dispatch('setNewActionProjectId', null);
        this.$store.dispatch('setCurrentActionId', -1);
        this.$store.dispatch('setCurrentAction', null);
      }

      this.$store.dispatch('setActionTrayViewMode', 'tasks');
      this.$store.dispatch('setActionTrayVisibility', true);
    },
    getHeading(key) {
      if (
        key === 'Overdue' ||
        key === 'Today' ||
        key === 'Tomorrow' ||
        key === 'No due date'
      ) {
        return key;
      }

      const date = moment(key);
      const today = moment();
      const next_week = moment().add(7, 'd');
      let format = 'D MMM';

      if (date.isBefore(next_week, 'd')) {
        format = 'dddd';
      } else if (!date.isSame(today, 'y')) {
        format = 'D MMM YYYY';
      }

      return date.format(format);
    },
    handleSearch(term) {
      this.search_term = term;
      this.get_actions();
    },
    showFilters() {
      this.$store.dispatch('setActionFiltersVisible', true);
    },
  },
  created() {
    this.$store.dispatch('setActionFilter', {
      key: 'assigneeId',
      value: [this.app_user.id],
    });
    this.get_actions();

    clearInterval(this.scrollTimer);
    this.scrollTimer = null;

    this.scrollTimer = setInterval(() => {
      if (!this.loadingNewData && this.actionCount < this.totalResults) {
        const view = document.querySelector('#main-view');
        const windowHeight = window.innerHeight - 80;

        if (view && windowHeight) {
          const distance_from_bottom =
            view.scrollHeight - windowHeight - view.scrollTop;
          if (distance_from_bottom < 150) {
            this.lazyLoad();
          }
        }
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.scrollTimer);
    this.scrollTimer = null;
  },
  components: {
    'action-card': ActionCard,
    'search-box': SearchBox,
    'action-filters': ActionFilters,
  },
  watch: {
    refresh_actions_trigger() {
      this.get_actions();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.dateGroup {
  position: relative;

  &:before {
    width: 1px;
    height: calc(100% - 140px);
    position: absolute;
    top: 110px;
    left: 106px;
    border-left: 1.5px solid rgba(175, 185, 195, 0.38);
    content: '';
    z-index: 0;
  }
}

.date-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 50px 0;

  hr {
    border-top: 1px solid #e2e5ec;
    flex: 1;
  }

  span {
    border-radius: 15px;
    height: 30px;
    color: #26292f;
    font-size: 13px;
    font-weight: 500;
    padding: 5px 0px 11px;
    text-align: center;
    margin: 0 15px;
    position: relative;
    top: 1px;
  }

  &.Today {
    span {
      background-color: white;
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  &.Overdue {
    span {
      background-color: $red;
      color: white;
      padding-left: 15px;
      padding-right: 15px;
    }
  }
}

.loader {
  width: 100%;
  text-align: center;
  font-size: 14px;
  margin: 30px 0;
  color: $sidebar-color;
  opacity: 0.5;
}

.list-move {
  transition: transform 0.5s;
}

.list-enter-active,
.list-leave-active {
  transition: none;
}

.flex-between {
  margin-top: 25px;
}
</style>
